import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-23c81131")

_pushScopeId("data-v-23c81131")
const _hoisted_1 = {
  key: 0,
  class: "countdown-second"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "time-ico" }, null, -1)
const _hoisted_3 = { class: "time-text" }
const _hoisted_4 = { class: "time-num" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.countdownSecond)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('timeLeft') + '：'), 1),
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.LeftTime), 1)
      ]))
    : _createCommentVNode("", true)
})